const tableTemplate = (editor) => {

    editor.BlockManager.add('tableTemplaye', {
        category: `Built In Templates`,
        label: `Table Template`,
        attributes: {},
        content: `
            <div>
                <nav class="navbar navbar-expand-lg navbar-light bg-light">
                    <div class="container px-4 px-lg-5">
                        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul class="navbar-nav me-auto mb-2 mb-lg-0 ms-lg-4">
                                <li class="nav-item nav-link active pointer" aria-current="page" href="#!">Home</li>
                                <li class="nav-item dropdown">
                                    <span class="nav-link dropdown-toggle pointer" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Actions</span>
                                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <li><span class="dropdown-item pointer" href="#!">Create a project</span></li>
                                        <li><span class="dropdown-item pointer" href="#!">Create a task</span></li>
                                        <li><span class="dropdown-item pointer" href="#!">Create a workpackage</span></li>
                                        <li><span class="dropdown-item pointer" href="#!">Create a deliverable</span></li>
                                    </ul>
                                </li>
                                <li class="nav-item nav-link pointer" href="#!">Tasks</li>
                            </ul>
                        </div>
                    </div>
                </nav>
                <header class="bg-dark py-2">
                    <div class="container px-4 px-lg-5">
                        <div class="text-center text-white">
                            <h1 class="display-4 fw-bolder">List of projects</h1>
                        </div>
                    </div>
                </header>
                <section class="py-5 height-section">
                    <div class="container px-4 px-lg-5">
                    <div class="table-responsive padding-style">
                        <table class="table table-stripped2 table-border">
                            <thead class="table-dark">
                                <tr>
                                <th>
                                    <span class="horiz-center-item table-line-height">Project</span>
                                </th>
                                <th>
                                    <span class="horiz-center-item table-line-height">Status</span>
                                </th>
                                <th>
                                    <span class="horiz-center-item table-line-height">Completed</span>
                                </th>
                                <th>
                                    <span class="horiz-center-item table-line-height">Created</span>
                                </th>
                                <th>
                                    <span class="horiz-center-item table-line-height">Action</span>
                                </th>
                                </tr>
                            </thead>
                            <tbody dataitems=getAllRows>
                                <tr dataitem=true>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td class="space-around-elements">
                                    <div class="btn pointer bi bi-pencil-square manage-btn">&nbsp;Manage</div>
                                    <div class="btn pointer bi bi-archive archive-btn">&nbsp;Archive</div>
                                    <div class="btn pointer bi bi-trash delete-btn">&nbsp;Delete</div>
                                </td>
                                </tr>
                                <tr dataitem=true>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td class="space-around-elements">
                                    <div class="btn pointer bi bi-pencil-square manage-btn">&nbsp;Manage</div>
                                    <div class="btn pointer bi bi-archive archive-btn">&nbsp;Archive</div>
                                    <div class="btn pointer bi bi-trash delete-btn">&nbsp;Delete</div>
                                </td>
                                </tr>
                                <tr dataitem=true>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td class="space-around-elements">
                                    <div class="btn pointer bi bi-pencil-square manage-btn">&nbsp;Manage</div>
                                    <div class="btn pointer bi bi-archive archive-btn">&nbsp;Archive</div>
                                    <div class="btn pointer bi bi-trash delete-btn">&nbsp;Delete</div>
                                </td>
                                </tr>
                                <tr dataitem=true>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td class="space-around-elements">
                                    <div class="btn pointer bi bi-pencil-square manage-btn">&nbsp;Manage</div>
                                    <div class="btn pointer bi bi-archive archive-btn">&nbsp;Archive</div>
                                    <div class="btn pointer bi bi-trash delete-btn">&nbsp;Delete</div>
                                </td>
                                </tr>
                                <tr dataitem=true>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td >
                                    <span class="horiz-center-item table-line-height">Cell</span>
                                </td>
                                <td class="space-around-elements">
                                    <div class="btn pointer bi bi-pencil-square manage-btn">&nbsp;Manage</div>
                                    <div class="btn pointer bi bi-archive archive-btn">&nbsp;Archive</div>
                                    <div class="btn pointer bi bi-trash delete-btn">&nbsp;Delete</div>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
                <footer class="py-5 bg-dark">
                    <div class="container"><p class="m-0 text-center text-white">Copyright &copy; ViLabs 2022</p></div>
                </footer>
            </div>
        `
    })

}

export default tableTemplate;